import styled from 'styled-components';

export const ActiveIssuesWidgetContainer = styled.div.attrs(() => ({
  className: 'widget-ui__main'
}))`
  max-height: 300px;
`;
